import React from "react";

// Canonical public domain — every public page canonicalizes here.
export const SITE_URL = "https://vs-partnerhub.com";
export const COMPANY_URL = "https://vs-solutions.in";
export const DEFAULT_DESCRIPTION =
  "VS PartnerHub by Vijay Software Solutions Pvt Ltd connects clients, vendors and staffing partners through enterprise partner management, procurement, staffing, agreements and business workflows.";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Per-page SEO for the SPA: unique title, description, canonical, robots and Open Graph.
export function useSEO({ title, description = DEFAULT_DESCRIPTION, path = "/", robots = "index,follow", jsonLd = null }) {
  React.useEffect(() => {
    const url = SITE_URL + path;
    document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", robots);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:image", `${SITE_URL}/og-image.jpg`);
    upsertMeta("property", "og:site_name", "VS PartnerHub");
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", `${SITE_URL}/og-image.jpg`);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = url;
    let script = null;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-jsonld";
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => { if (script) script.remove(); };
  }, [title, description, path, robots]);
}

export function breadcrumbLd(trail) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: trail.map(([name, path], i) => ({
      "@type": "ListItem", position: i + 1, name, item: SITE_URL + path,
    })),
  };
}

export function webPageLd({ title, description, path }) {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: title,
    description,
    url: SITE_URL + path,
    isPartOf: { "@id": `${SITE_URL}/#website` },
    publisher: { "@id": `${COMPANY_URL}/#organization` },
  };
}
